(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  function homepageGridItems(grid) {
    return Array.from(grid.children).filter(item => item.classList.contains('resource-list__item'));
  }

function homepageRowBatch(grid) {
  return 15;
}

  function homepageState(section, grid, button) {
    if (!section.availableWineState) {
      section.availableWineState = {
        pending: [],
        nextHref: button.href,
        seen: new Set(Array.from(grid.querySelectorAll('a[href*="/products/"]')).map(link => new URL(link.href, location.href).pathname))
      };
    }
    return section.availableWineState;
  }

  async function fillHomepageRows(button, initial = false) {
    const section = button.closest('[data-homepage-load-more]');
    if (!section || button.getAttribute('aria-busy') === 'true') return;
    const grid = section.querySelector('.resource-list--grid');
    if (!grid) return;
    const state = homepageState(section, grid, button);
    const batch = homepageRowBatch(grid);
    const count = homepageGridItems(grid).length;
    const target = initial ? Math.max(batch, Math.ceil(count / batch) * batch) : Math.ceil((count + batch) / batch) * batch;
    let needed = target - count;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading…';
    const visited = new Set();

    try {
   while (state.pending.length < needed && state.nextHref) {
        const url = new URL(state.nextHref, location.href);
        url.searchParams.set('section_id', section.dataset.sectionId);
        if (visited.has(url.href)) throw new Error('Pagination repeated a page');
        visited.add(url.href);
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Could not load products');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextSection = Array.from(parsed.querySelectorAll('[data-homepage-load-more]')).find(item => item.dataset.sectionId === section.dataset.sectionId);
        if (!nextSection) throw new Error('Matching section not found');
        const nextGrid = nextSection.querySelector('.resource-list--grid');
        if (!nextGrid) throw new Error('Product grid not found');
        for (const item of homepageGridItems(nextGrid)) {
          const link = item.querySelector('a[href*="/products/"]');
          const key = link ? new URL(link.href, location.href).pathname : null;
          if (key && state.seen.has(key)) continue;
          if (key) state.seen.add(key);
          state.pending.push(document.importNode(item, true));
        }
        const nextButton = nextSection.querySelector('[data-homepage-more-button]');
        state.nextHref = nextButton instanceof HTMLAnchorElement ? nextButton.href : null;
      }

grid.append(...state.pending.splice(0, needed));
      button.hidden = !state.nextHref && !state.pending.length;
      if (state.nextHref) button.href = state.nextHref;
      button.textContent = 'View more';
    } catch (error) {
      console.error('Unable to fill homepage product rows:', error);
      button.textContent = 'Try again';
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-homepage-more-button]');
    if (!(button instanceof HTMLAnchorElement) || !button.closest('[data-homepage-load-more]')) return;
    event.preventDefault();
    fillHomepageRows(button);
  });

  function initializeHomepageRows(scope) {
    const sections = [
      ...(scope.matches?.('[data-homepage-load-more]') ? [scope] : []),
      ...scope.querySelectorAll('[data-homepage-load-more]')
    ];

    sections.forEach(section => {
      const button = section.querySelector('[data-homepage-more-button]');
      if (button instanceof HTMLAnchorElement) {
        fillHomepageRows(button, true);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHomepageRows(document));
  } else {
    initializeHomepageRows(document);
  }
  document.addEventListener('shopify:section:load', event => initializeHomepageRows(event.target));

  } catch(e) { console.error(e); }
})();
})();
